// extracted by mini-css-extract-plugin
module.exports = {"titleCase":"style_titleCase__PyFE6"};